import { render, staticRenderFns } from "./order_gift_status.vue?vue&type=template&id=d72f2db0&scoped=true&"
import script from "./order_gift_status.vue?vue&type=script&lang=js&"
export * from "./order_gift_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72f2db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d72f2db0')) {
      api.createRecord('d72f2db0', component.options)
    } else {
      api.reload('d72f2db0', component.options)
    }
    module.hot.accept("./order_gift_status.vue?vue&type=template&id=d72f2db0&scoped=true&", function () {
      api.rerender('d72f2db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/order_gift_status.vue"
export default component.exports